import { Controller } from '@hotwired/stimulus';
import { toggleVisiblity } from '@frontend/utils/dom';

export default class extends Controller {
  static targets = ['textSource', 'characterCounter'];
  static values = {
    maxLength: Number,
    isAlwaysVisible: { type: Boolean, default: false },
  };

  async connect() {
    this.limitWasExceeded = false;

    this.textSourceTarget.addEventListener(
      this.changeEventByTagName(this.textSourceTarget),
      this.update.bind(this)
    );
    this.update();
  }

  update() {
    const textLength = this.textByTagName(this.textSourceTarget).length;
    this.updateCharacterCounter(textLength);

    toggleVisiblity(
      this.characterCounterTarget,
      textLength > 0 || this.isAlwaysVisibleValue
    );
  }

  changeEventByTagName(node) {
    switch (node.tagName) {
      case 'TEXTAREA':
      case 'INPUT':
        return 'keyup';
      case 'TRIX-EDITOR':
        return 'trix-change';
    }
  }

  textByTagName(node) {
    switch (node.tagName) {
      case 'TEXTAREA':
      case 'INPUT':
        return node.value;
      case 'TRIX-EDITOR':
        return node.innerText;
    }
  }

  updateCharacterCounter(textLength) {
    if (this.maxLengthValue > 0) {
      this.characterCounterTarget.innerText = `${textLength} / ${this.maxLengthValue} Zeichen`;
      const isInvalid = textLength >= this.maxLengthValue;

      if (isInvalid && !this.limitWasExceeded) {
        this.limitWasExceeded = true;
        this.element.dispatchEvent(
          new CustomEvent('character-counter:limit-exceeded', { bubbles: true })
        );
      } else if (this.limitWasExceeded) {
        this.limitWasExceeded = false;
        this.element.dispatchEvent(
          new CustomEvent('character-counter:limit-kept', { bubbles: true })
        );
      }

      this.characterCounterTarget.classList.toggle(
        'character-counter--invalid',
        isInvalid
      );
    } else {
      this.characterCounterTarget.innerText = `${textLength} Zeichen`;
    }
  }
}
